import type { AdminFeedback } from '@steado/admin-contract/feedback';

import type { ToneName } from '@/components/table/tone';

/**
 * The words and tones the feedback table and its drawer share. A plain
 * module rather than exports beside a component, so fast refresh keeps
 * working for both screens.
 */

export const FEEDBACK_STATUS_LABELS: Record<AdminFeedback['status'], string> = {
  open: 'Open',
  resolved: 'Resolved',
  dismissed: 'Dismissed',
};

export const FEEDBACK_STATUS_TONES: Record<AdminFeedback['status'], ToneName> = {
  open: 'warn',
  resolved: 'ok',
  dismissed: 'mute',
};

export const FEEDBACK_KIND_LABELS: Record<AdminFeedback['kind'], string> = {
  bug: 'Bug',
  idea: 'Idea',
};

export const FEEDBACK_KIND_TONES: Record<AdminFeedback['kind'], ToneName> = {
  bug: 'err',
  idea: 'info',
};

/** "4.12.0 · android 15", or null when the sender kept app details out. */
export function appDetailsOf(report: AdminFeedback): string | null {
  if (report.appVersion === null) return null;
  return (
    report.appVersion +
    (report.devicePlatform === null ? '' : ` · ${report.devicePlatform}`) +
    (report.deviceOsVersion === null ? '' : ` ${report.deviceOsVersion}`)
  );
}
